import { ProgressNoteKind } from "@/types/__generated__/union-types"

export const EXPORT_SCOPE = {
  full: "full",
  custom: "custom",
} as const

export type ExportScope = (typeof EXPORT_SCOPE)[keyof typeof EXPORT_SCOPE]

export const PROGRESS_NOTE_TYPE = {
  all: "ALL",
  medical: "MEDICAL",
  administrative: "ADMINISTRATIVE",
} as const satisfies { all: string; medical: ProgressNoteKind; administrative: ProgressNoteKind }

export type ProgressNoteType = (typeof PROGRESS_NOTE_TYPE)[keyof typeof PROGRESS_NOTE_TYPE]

export const PREVIEW_STATUS = {
  idle: "idle",
  generating: "generating",
  loaded: "loaded",
  error: "error",
  stale: "stale",
} as const

export type PreviewStatus = (typeof PREVIEW_STATUS)[keyof typeof PREVIEW_STATUS]

export const PREVIEW_STAGE = {
  fetching: "fetching",
  generating: "generating",
} as const

export type PreviewStage = (typeof PREVIEW_STAGE)[keyof typeof PREVIEW_STAGE]

export const PREVIEW_ERROR_KEY = {
  generic: "patient.recordExtract.preview.error",
  noContact: "patient.recordExtract.preview.error.noContact",
  expired: "patient.recordExtract.preview.error.expired",
} as const

export type PreviewErrorKey = (typeof PREVIEW_ERROR_KEY)[keyof typeof PREVIEW_ERROR_KEY]

export interface EpisodeOfCareOption {
  id: string
  label: string
}
